import { jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Inline, Badge } from "braid-design-system";
import { translations } from "../../../../components/.vocab/index.mjs";
import { root } from "./Badges.css.mjs";
const Badges = ({ badges }) => {
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsx(Box, { className: root, children: /* @__PURE__ */ jsx(Inline, { space: "xsmall", children: badges.map((badge) => /* @__PURE__ */ jsx(
    Badge,
    {
      id: badge.id,
      weight: "strong",
      tone: badge.tone,
      children: t(badge.children)
    },
    `bx-brand-card-badge-${badge.id}`
  )) }) });
};
export {
  Badges
};
